import React, { useCallback, useState } from 'react';

import Button from '@components/dataEntry/button/Button';
import {
  EditBtnWrap,
  EditHeaderWrapper,
} from '@styles/common/EditHeaderWrapper';
import exitBrowserAlert from '@utils/browserAlert';
import { useNavigate } from 'react-router-dom';
import { getEditPagePath } from '@utils/getPath';
import { useRecoilState } from 'recoil';
import { themeBgFileListState } from '@atom/posting/EditPosting';
import {
  addHistoryDoc,
  updateHistorySetDoc,
} from '@store/firebase/history/update-history';
import { themeSetState } from '@atom/setting/globalStyle';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';

type Props = {};
function EditHeader({}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const collectionPath = getEditPagePath();

  //recoil
  const [themeSet, setThemeSet] = useRecoilState(themeSetState);
  const [bgFileList, setBgFileList] = useRecoilState(themeBgFileListState);
  //end - recoil

  const handleSaveHistory = useCallback(async () => {
    await updateHistorySetDoc({
      collectionPath: CollectionPath.MAINHOME,
      docId: `${collectionPath}Page`,
      themeSet: { ...themeSet },
      bgFileList,
    });
    handleReset();
    navigate(`/${collectionPath}`);
  }, [collectionPath, themeSet, bgFileList]);

  const handleReset = useCallback(() => {
    setThemeSet({});
    setBgFileList({});
  }, []);

  const exitEditPosting = useCallback(() => {
    navigate(`/${collectionPath}`);
  }, [collectionPath]);

  return (
    <EditHeaderWrapper>
      <Button
        onClick={() => exitBrowserAlert({ handleExit: exitEditPosting })}
        shape="stroke"
      >
        나가기
      </Button>
      <EditBtnWrap>
        <Button onClick={handleSaveHistory} pending={isLoading}>
          내용 저장 후 나가기
        </Button>
      </EditBtnWrap>
    </EditHeaderWrapper>
  );
}

export default EditHeader;
